/// <reference path="../../typings/browser.d.ts" />

namespace Application.Services {
    'use strict';

    export interface IFlexSettings extends IFlexRootScope {
        settings?: {
            // number of thumbs per row in the source panel of matrix room
            sourceColumns: number;

            // number of thumbs per row in the destination panel of matrix room
            destinationColumns: number;

            // enable/disable the dark theme
            darkTheme: boolean;

            // show/hide the alarms console when entering in monitoring room
            alarmConsoleHiddenInMonitoring: boolean;

            // show/hide the alarms console
            alarmConsoleSticky: boolean;

            // show/hide IP addresses on network map
            showIps: boolean;

            // enable/disable notifications
            notifications: boolean;

            // critical alarms notification frequency, in minutes
            criticalAlarmsNotificationsFreq: number;
        };

        criticalAlarmsNotificationsValues?: [{text: string, value: number}];
    }

    export class SettingsService {
        public static $name: string = "settingsService";
        public static $inject: string[] = ['$rootScope', '$cookies'];

        private static cookiesOptions: ng.cookies.ICookiesOptions = 
                     { expires: Common.Utils.getCookieExpirationDate(), secure: location.protocol === 'https:' };
        

        public settings: IFlexSettings;

        private $rootScope: IFlexSettings;
        private $cookies: ng.cookies.ICookiesService;

        constructor($rootScope: IFlexRootScope,
                    $cookies: ng.cookies.ICookiesService) {
            this.$rootScope = $rootScope;
            this.$cookies = $cookies;

            this.$rootScope.settings = {
                sourceColumns: 4,
                destinationColumns: 4,
                darkTheme: false,
                alarmConsoleHiddenInMonitoring: false,
                alarmConsoleSticky: false,
                showIps: true,
                notifications: true,
                criticalAlarmsNotificationsFreq: 5,
            };

            this.$rootScope.criticalAlarmsNotificationsValues = [
                {"text": "OFF", "value": 0},
                {"text": "1", "value": 1},
                {"text": "2", "value": 2},
                {"text": "5", "value": 5},
                {"text": "10", "value": 10},
                {"text": "20", "value": 20},
            ];

            for (let setting of Object.keys(this.$rootScope.settings)) {
                this.loadCookieSettingAndStartWatcher(setting);
            }
        }

        public setTheme(): void {
            (this.$rootScope.settings.darkTheme) ? Common.Theme.setDarkTheme() : Common.Theme.setDefaultTheme();
        }

        private loadCookieSettingAndStartWatcher(setting: string): void {
            let cookieVal: string = this.$cookies.get(setting);
            if (cookieVal) {
                if (!isNaN(Number(cookieVal)))
                    this.$rootScope.settings[setting] = Number(this.$cookies.get(setting));
                else
                    this.$rootScope.settings[setting] = this.$cookies.get(setting) === 'true';
            }

            this.$rootScope.$watch('settings.' + setting, (newValue: number | boolean, oldValue: number | boolean) => {
                // if (newValue !== null && newValue !== undefined && newValue !== NaN && newValue !== oldValue) { // tslint:disable-line
                if (Common.Utils.exists(newValue) && newValue !== oldValue) {
                    this.$rootScope.settings[setting] = newValue;
                    this.$cookies.put(setting, newValue.toString(), SettingsService.cookiesOptions);

                    if (setting === 'darkTheme') this.setTheme();
                }
            });
        }
    }
}